import type {
  AttachmentDto,
  ProductionReasonDto,
  ShopOperationDetailDto,
  ShopQueueItemDto,
} from "@grizzly/shared";
import { postForm, request } from "../http.js";

export const shopFloorApi = {
  listShopWorkCenters: () =>
    request<{ items: { id: string; code: string; name: string }[] }>(
      "/shop-floor/work-centers"
    ),
  listShopQueue: (workCenterId?: string) =>
    request<{ items: ShopQueueItemDto[] }>(
      `/shop-floor/queue?limit=100${workCenterId ? `&workCenterId=${encodeURIComponent(workCenterId)}` : ""}`
    ),
  listShopReasons: () => request<{ items: ProductionReasonDto[] }>("/shop-floor/reasons"),
  getShopOperation: (id: string) =>
    request<{ operation: ShopOperationDetailDto }>(`/shop-floor/operations/${id}`),
  startShopOperation: (id: string) =>
    request<{ operation: ShopOperationDetailDto }>(`/shop-floor/operations/${id}/start`, {
      method: "POST",
      body: {},
    }),
  pauseShopOperation: (id: string, note?: string) =>
    request<{ operation: ShopOperationDetailDto }>(`/shop-floor/operations/${id}/pause`, {
      method: "POST",
      body: { note },
    }),
  resumeShopOperation: (id: string) =>
    request<{ operation: ShopOperationDetailDto }>(
      `/shop-floor/operations/${id}/resume`,
      {
        method: "POST",
        body: {},
      }
    ),
  completeShopOperation: (id: string, input: object) =>
    request<{ operation: ShopOperationDetailDto }>(
      `/shop-floor/operations/${id}/complete`,
      {
        method: "POST",
        body: input,
      }
    ),
  blockShopOperation: (id: string, description: string, severity: string) =>
    request<{ operation: ShopOperationDetailDto }>(`/shop-floor/operations/${id}/block`, {
      method: "POST",
      body: { description, severity },
    }),
  unblockShopOperation: (id: string, note?: string) =>
    request<{ operation: ShopOperationDetailDto }>(
      `/shop-floor/operations/${id}/unblock`,
      {
        method: "POST",
        body: { note },
      }
    ),
  uploadShopOperationPhoto: (id: string, file: File) => {
    const form = new FormData();
    form.set("file", file, file.name);
    return postForm<{ attachment: AttachmentDto }>(
      `/shop-floor/operations/${id}/photos`,
      form
    );
  },
};
